import { render, staticRenderFns } from "./desade.vue?vue&type=template&id=dcdccd4a&scoped=true&"
import script from "./desade.vue?vue&type=script&lang=js&"
export * from "./desade.vue?vue&type=script&lang=js&"
import style0 from "./desade.vue?vue&type=style&index=0&id=dcdccd4a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dcdccd4a",
  null
  
)

export default component.exports